import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';

// Import translations
import commonDE from './locales/de/common.json';
import commonEN from './locales/en/common.json';
import validationDE from './locales/de/validation.json';
import validationEN from './locales/en/validation.json';
import cartDE from './locales/de/cart.json';
import cartEN from './locales/en/cart.json';
import customerDE from './locales/de/customer.json';
import customerEN from './locales/en/customer.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    defaultNS: 'common',
    ns: ['common', 'validation', 'cart', 'customer'],

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    resources: {
      de: {
        common: commonDE,
        validation: validationDE,
        cart: cartDE,
        customer: customerDE,
      },
      en: {
        common: commonEN,
        validation: validationEN,
        cart: cartEN,
        customer: customerEN,
      },
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    debug: process.env.NODE_ENV === 'development',
  });

// Sync dayjs locale when language changes
i18n.on('languageChanged', (lng) => {
  const dayjsLocale = lng === 'de' ? 'de' : 'en';
  dayjs.locale(dayjsLocale);
});

export default i18n;
